<template>
  <el-select
    v-model="value"
    @change="change"
    clearable
    filterable

    placeholder="渠道">
    <el-option
      v-for="item in channelNameOptions"
      :key="item.channelId"
      :label="item.channelName"
      :value="item.channelId" />
  </el-select>
</template>

<script>
import { getChannelName } from '@/api/select'
import {hot} from "@/api/hot"

export default {
  props: {
    modelValue: [String, Number],
    channelType: {
      type: Number,
      default: 1
    }
  },
  emits: ['update:modelValue', 'change'],
  data () {
    return {
      channelNameOptions: [],
      value: this.modelValue,
    }
  },
  watch: {
    modelValue (newVal) {
      if (this.value === newVal) return
      this.value = newVal
      this.change(newVal)
    }
  },
  created () {
    this.getChannelName()
  },
  methods: {
    getChannelName () {
      if(this.channelType!==100){
        getChannelName({ channelType: this.channelType }).then(res => {
          if (res.code === 200) {
            this.channelNameOptions = res.data
          }
        })
      }else{
        getChannelName().then(res => {
          if (res.code === 200) {
            this.channelNameOptions = res.data
          }
        })
      }
    },
    change (item) {
      let data={
        maker:"channelOnThe",
        onTheOrderId:item
      }
      hot(data)
      this.$emit('update:modelValue', item)
      this.$emit('change', item)
    },
    // removeBlank(val) {
    //   this.value = val.replace(/^\s+|\s+$/gm, '')
    // }
  }
}
</script>

<style scoped>

</style>
